import React, { useState, useEffect } from 'react'
import './userdashboardwithdraw.css'
import { useNavigate, Link } from 'react-router-dom'
import { MdClose } from 'react-icons/md'
import { FiChevronRight, FiArrowUpRight, FiClock } from 'react-icons/fi'
import Swal from 'sweetalert2'
import Loader from '../Loader'
import Userdashboardheader from '../userdashboardheader/Userdashboardheader'
import DashboardTopbar from '../dashboardShell/DashboardTopbar'
import PageHero from '../dashboardShell/PageHero'
import WithdrawReview from '../WithdrawReview'

const withdrawMethods = [
  { id:1, image:'/btc.png',     method:'BTC',            min:1 },
  { id:2, image:'/etherium.png',method:'ETH',            min:10 },
  { id:3, image:'/tron.png',    method:'Tether (TRC-20)',min:1 },
  { id:4, image:'/solana.png',  method:'Solana (SOL)',   min:1 },
]

const Toast = Swal.mixin({ toast:true, position:'top-end', showConfirmButton:false, timer:3000, timerProgressBar:true })

const Userdashboardwithdraw = ({ route }) => {
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false)
  const [userData, setUserData] = useState()
  const [selectedCrypto, setSelectedCrypto] = useState(null)
  const [withdrawAmount, setWithdrawAmount] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [activeMethod, setActiveMethod] = useState(null)
  const [checkoutPage, setCheckoutPage] = useState(false)

  useEffect(() => {
    setLoader(true)
    if (localStorage.getItem('token')) {
      const getData = async () => {
        const req = await fetch(`${route}/api/getData`, {
          headers: { 'x-access-token': localStorage.getItem('token') }
        })
        const res = await req.json()
        setUserData(res)
        if (res.status === 'error') navigate('/login')
        setLoader(false)
      }
      getData()
    } else {
      navigate('/login')
    }
  }, [])

  const handleNext = () => {
    const amt = parseInt(withdrawAmount)
    if (isNaN(amt)) return Toast.fire({ icon:'warning', title:'Amount must be a number' })
    if (amt < activeMethod.min) return Toast.fire({ icon:'warning', title:`Minimum withdrawal is $${activeMethod.min}` })
    setCheckoutPage(true)
  }

  if (checkoutPage) {
    return <WithdrawReview Active={activeMethod} withdrawAmount={parseInt(withdrawAmount)} closepage={() => setCheckoutPage(false)} route={route} funded={userData?.funded} />
  }

  // the backend refuses withdrawals until KYC is approved; say so before the user fills anything in
  const kycApproved = userData?.kycStatus === 'approved'
  const kycProcessing = userData?.kycStatus === 'processing'

  const openMethod = (option) => {
    if (userData && !kycApproved) {
      Toast.fire({
        icon: 'warning',
        title: kycProcessing ? 'Your KYC is still under review' : 'Please complete KYC verification first',
      })
      return
    }
    setSelectedCrypto(option)
    setActiveMethod(option)
    setWithdrawAmount('')
    setShowModal(true)
  }

  return (
    <div className="ud-layout">
      {loader && <Loader />}
      <Userdashboardheader route={route} />

      <div className="ud-main">
        <DashboardTopbar route={route} title="Withdraw" />

        <div className="ud-content">

          {showModal && activeMethod && (
            <div className="ud-modal-overlay">
              <div className="ud-modal">
                <button className="ud-modal-close" onClick={() => setShowModal(false)} aria-label="Close"><MdClose size={16} /></button>
                <div className="udf-modal-coin">
                  <img src={activeMethod.image} alt="" className="udf-coin-img" />
                  <div>
                    <p className="ud-modal-title">Withdraw via {activeMethod.method}</p>
                    <p className="ud-modal-sub">Minimum: <strong>${activeMethod.min}</strong></p>
                  </div>
                </div>
                <div className="ud-amount-input-wrap">
                  <span className="ud-amount-prefix">$</span>
                  <input type="number" placeholder="0.00" className="ud-amount-input" autoFocus
                    value={withdrawAmount} onChange={e => setWithdrawAmount(e.target.value)} />
                  <span className="ud-amount-suffix">USD</span>
                </div>
                <div className="ud-modal-actions">
                  <button className="ud-btn-ghost" onClick={() => setShowModal(false)}>Cancel</button>
                  <button className="ud-btn-primary" onClick={handleNext}>Continue <FiChevronRight /></button>
                </div>
              </div>
            </div>
          )}

          <PageHero
            icon={<FiArrowUpRight />}
            eyebrow="Withdraw funds"
            title="Request a withdrawal"
            description="Choose the cryptocurrency you want to receive, enter an amount, and provide your wallet address on the next step."
          >
            <div className="ud-hero-figure">
              <span>Available balance</span>
              <strong>${Number(userData?.funded || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</strong>
            </div>
          </PageHero>

          {userData && !kycApproved && (
            <div className="ud-notice">
              <span>
                {kycProcessing
                  ? 'Your identity verification is under review. You can withdraw once it is approved.'
                  : 'Withdrawals are available once your identity is verified. '}
                {!kycProcessing && <Link to="/kyc">Complete KYC →</Link>}
              </span>
            </div>
          )}

          <div className="ud-section-header udf-section-row">
            <div>
              <h2>Withdrawal methods</h2>
              <p>Select a cryptocurrency to continue.</p>
            </div>
            <button className="ud-btn-ghost" onClick={() => navigate('/withdrawlogs')}>
              <FiClock /> Withdrawal history
            </button>
          </div>

          <div className="udf-method-grid">
            {withdrawMethods.map(option => (
              <button
                key={option.id}
                className={`udf-method-tile${selectedCrypto?.id === option.id ? ' active' : ''}`}
                onClick={() => openMethod(option)}
              >
                <img src={option.image} alt="" className="udf-coin-img" />
                <span className="udf-method-text">
                  <span className="udf-method-name">{option.method}</span>
                  <span className="udf-method-min">Min ${option.min}</span>
                </span>
                <FiChevronRight className="udf-method-arrow" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Userdashboardwithdraw
